import { Result, ok, err } from '@xlearn/common';

export enum Exit {
  none,
  timeout,
  suspend,
  logout,
  normal
}

export function parseExitString(value: string): Result<Exit, false> {
  switch (value) {
    case '':
      return ok(Exit.normal);
    case 'time-out':
      return ok(Exit.timeout);
    case 'suspend':
      return ok(Exit.suspend);
    case 'logout':
      return ok(Exit.logout);
    case 'normal':
      return ok(Exit.normal);
    default:
      return err(false);
  }
}
